import { render, staticRenderFns } from "./HorizontalDivider.vue?vue&type=template&id=7b024f06&scoped=true"
import script from "./HorizontalDivider.vue?vue&type=script&lang=js"
export * from "./HorizontalDivider.vue?vue&type=script&lang=js"
import style0 from "./HorizontalDivider.vue?vue&type=style&index=0&id=7b024f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b024f06",
  null
  
)

export default component.exports